import React from 'react';

const About = () => {
    const values = [
        { emoji: '🌿', title: 'Ingredientes de Calidad', description: 'Seleccionamos los mejores ingredientes naturales.' },
        { emoji: '🎂', title: 'Recetas Artesanales', description: 'Recetas tradicionales perfeccionadas con pasión.' },
        { emoji: '💕', title: 'Hecho con Amor', description: 'Cada postre lleva todo nuestro cariño y dedicación.' },
        { emoji: '🎉', title: 'Para Cada Ocasión', description: 'Desde una once especial hasta celebraciones inolvidables.' },
    ];

    return (
        <section id="nosotros" className="py-20 md:py-28 bg-gradient-to-b from-white via-dulce-pink-50/30 to-white relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-dulce-pink-100/40 rounded-full blur-3xl" />
            <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-dulce-cream-100/40 rounded-full blur-3xl" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="animate-on-scroll">
                    <div className="text-center mb-16">
                        <span className="inline-block text-dulce-pink-500 text-sm font-semibold tracking-widest uppercase mb-3">
                            💕 Sobre Nosotros 💕
                        </span>
                        <h2 className="section-title text-gray-800">
                            Dulzura <span className="text-gradient-pink">Artesanal</span>
                        </h2>
                        <p className="max-w-2xl mx-auto text-gray-600 text-lg mt-4">
                            En <strong className="text-dulce-pink-600">Repostería Dulce Mora</strong>, cada postre es una historia de amor.
                            Creamos delicias artesanales con ingredientes naturales y todo nuestro corazón.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                        {values.map((value, index) => (
                            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-500 border border-dulce-pink-100/50 text-center group">
                                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-dulce-pink-50 to-dulce-cream-50 rounded-2xl flex items-center justify-center shadow-inner group-hover:scale-110 transition-transform duration-300">
                                    <span className="text-3xl">{value.emoji}</span>
                                </div>
                                <h3 className="font-playfair text-lg font-bold text-gray-800 mb-2">{value.title}</h3>
                                <p className="text-gray-500 text-sm leading-relaxed">{value.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;